<script>
import request from '@utils/request'

export default {
  props: {
    isDeleteSave: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: String,
      required: true,
      validator: function (value) {
        return ['staff', 'merchant', 'product', 'prepaid', 'hotel'].indexOf(value) !== -1
      },
    },
    single: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: ''
    },
    propsMoreHW: {
      type: Boolean,
      default: false,
    },
    // 是否立刻刪除
    immediateDelete: {
      type: Boolean,
      default: true
    },
    modelSource: {
      type: String,
      default: ''
    },
    sizeLimit: {
      type: Number,
      default: 25,
    }
  },
  data() {
    return {
      fileList: Object.assign([], this.value),
      tryingToUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  computed: {
    showUploadBtn() {
      return this.single ? this.value.length === 0 : true
    },
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      // 前提：是商品模組，另外加上如果傳進有值，但是fileList還是空，則補上fileList
      if (this.modelSource === 'goods' && this.value.length > 0 && this.fileList.length === 0) {
        this.fileList = Object.assign([], this.value)
      }
    })
  },
  methods: {
    emitInput() {
      this.$emit('input', [...this.fileList])
    },
    beforeImageUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 <= this.sizeLimit

      if (!isJPGOrPNG) {
        this.$message.error('上傳的圖片只能是 JPG 或 PNG 或 GIF 格式')
      }
      if (!isLt2M) {
        this.$message.error(`上傳的圖片大小不能超過 ${this.sizeLimit} MB`)
      }
      return isJPGOrPNG && isLt2M
    },
    async handleUpload(params) {
      const formData = new FormData()
      formData.append('files[]', params.file)

      this.tryingToUpload = true
      const uploadedValue = await request.post('/admin/merchant/media/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      this.fileList.push({
        type: 'image',
        path: uploadedValue,
      })

      this.tryingToUpload = false
      this.emitInput()
    },
    async handleRemove(path) {
      const isExternal = /^(https?:)/.test(path)
      if (!isExternal) {
        const formData = new FormData()
        formData.append('paths[]', path)
        formData.append('resource', this.resource)
        if (this.immediateDelete) {
          request.post('/admin/merchant/media/delete', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
        }
      }
      this.afterHandleRemove(path)
    },
    afterHandleRemove(path) {
      this.fileList.some((file, index) => {
        if (file.path === path) {
          this.fileList.splice(index, 1)
          return true
        }
        return false
      })
      this.emitInput()
      if (this.isDeleteSave) {
        this.$emit('deleteSave')
      }
    },
    handlePreview(file) {
      this.dialogImageUrl = file
      this.dialogVisible = true
    },
    clearFileList() {
      this.fileList = []
      this.emitInput()
    },
  },
}
</script>

<template>
  <div v-show="showUpload" :class="$style.wrap">
    <div v-for="(file, index) in fileList" :key="`image-and-action--${index}`"
      :class="[$style.uploader, 'image-and-action', propsMoreHW ? $style.productImgSize : '']">
      <el-image v-if="file.path" :src="file.path" fit="cover">
        <div slot="placeholder">
          載入中
          <span class="dot">...</span>
        </div>
      </el-image>
      <p v-if="index === 0 && type === 'service'" class="first" style="font-size: 12px; color: darkgray">
        <BaseIcon name="flag" :icon-style="'fal'" /> 此為服務項目首圖
      </p>
      <!-- 遮罩 -->
      <span v-if="file.path" :class="$style.actions">
        <el-tooltip effect="dark" content="預覽圖片" placement="top">
          <span @click="handlePreview(file.path)">
            <BaseIcon name="eye" />
          </span>
        </el-tooltip>
        <el-tooltip effect="dark" content="刪除圖片" placement="top">
          <span @click="handleRemove(file.path)">
            <BaseIcon name="trash-alt" />
          </span>
        </el-tooltip>
      </span>
    </div>
    <el-upload v-if="showUploadBtn" ref="el-upload" v-loading="tryingToUpload" list-type="picture-card" action="string"
      :http-request="handleUpload" :before-upload="beforeImageUpload" :show-file-list="false"
      :class="[$style.uploader, $style['add-btn'], propsMoreHW ? $style.productImgSize : '']">
      <div class="iconBg">
        <BaseIcon name="image" />
      </div>
      <div class="text">點擊上傳圖片</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" width="1135px" top="0" append-to-body>
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<style lang="scss" module>

.wrap {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #dcdfe6;
  padding: 10px 0 0;

  :global {
    .image-and-action {
      position: relative;
    }

    .el-upload--picture-card {
      background-color: white;
    }
  }
}

.uploader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 23%;
  height: 130px;
  margin: 0;
  // overflow: hidden;
  // margin: 0 5px 50px;
  margin-bottom: 50px;

  &:not(:last-child) {
    margin-right: 10px;
  }

  :global {
    .first {
      width: 100%;
      text-align: left;
      // position:absolute;
      margin-top: 0;
      margin-bottom: 0;
      // bottom:-25px
    }

    .el-upload,
    .el-image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: $color-text-light;
      border-radius: 8px;
    }
  }

  &__icon {
    font-size: ms(12);
  }

  &__limit {
    margin-top: 10px;
    line-height: 1.5;
    color: $color-text-light;
  }

  &--circle {
    width: 150px;
    height: 150px;
    margin: auto;
    border-radius: 50%;

    .actions {
      border-radius: 50%;
    }
  }

  &.is-emtpy {
    border: 1px dashed $color-text-placeholder;

    &:hover :global {

      .el-upload,
      .el-image {
        color: darken($color-text-placeholder, 20);
      }
    }
  }
}

.add-btn {
  :global {
    .el-upload {
      flex-direction: column;

      .iconBg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        border-radius: 100%;
        height: 60px;
        background-color: $color-input-bg;

        svg {
          font-size: 24px;
          color: $color-primary;
        }
      }

      .text {
        height: auto;
        line-height: 31px;
        font-size: 14px;
        color: #404040;
      }
    }
  }
}

.actions {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: ms(8);
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: $fade-transition;

  span {
    cursor: pointer;

    +span {
      margin-left: 25px;
    }
  }

  &:hover {
    opacity: 1;
  }
}

.productImgSize {
  width: 382px;
  height: 216px;
}
</style>
